import BaseModal from '@/vcs/_shared/modals/BaseModal.vue'

import { required } from 'vuelidate/lib/validators'
import formValidator from '@/mixins/form-validator.js'
import PrefixesMixin from '@/mixins/prefixes.js'
import CurrentUserResolver from '@/mixins/current-user-resolver.js'
import AddDeliveryRequestComment from '@/vcs/_shared/modals/frontex-delivery/add-delivery-request-comment/cmp.vue'
import UserSearchSelect from './user-search-select.vue'
import UserAndPhoneSearchSelect from './user-and-phone-search-select.vue'

export default {
  name: 'AddDeliveryRequestReceiverData',
  extends: BaseModal,
  mixins: [formValidator, PrefixesMixin, CurrentUserResolver],
  data: function () {
    return {
      user: null,
      userOrPhone: null,
      phone: '',
      phonePrefix: '',
      errors: {},
      validatedItemKey: 'user',
      submitted: false,
    }
  },
  // watch: {
  //   currentUser: {
  //     handler: function () {
  //       this.user.phone = this.currentUser.phone
  //       this.user.phonePrefix = this.currentUser.phonePrefix
  //     },
  //     deep: true,
  //   },
  // },
  mounted() {
    this.phonePrefix = '48'
  },
  methods: {
    provideReceiverData() {
      // e ? e.preventDefault() : null
      // this.submitted = true
      // this.validateForm()
      // if (Object.keys(this.errors).length > 0) {
      //   toastStore.commit('error', {
      //     message: this.$t('messages.validationErrorFillFields'),
      //   })
      // } else {
      //   this.openCommentModal()
      // }
      this.openCommentModal()
    },

    openCommentModal() {
      let userOrPhone
      if (this.userOrPhone?.id) {
        userOrPhone = this.userOrPhone
      }
      this.$store.commit('modal/open', {
        cmp: AddDeliveryRequestComment,

        animation: 'slide-left-modal',
        data: {
          collectionPoint: this.data.collectionPoint,
          phonePrefix: this.phonePrefix,
          phone: this.phone,
          sender: this.currentUser,
          receiver: this.user || userOrPhone,
        },
      })
    },

    userOrPhoneSelected(data) {
      // INFO: We update phoneNumber only during option creation
      if (this.isCreatedOption(data)) {
        const phone = data.itemData
        this.phone = phone
      } else {
        this.phone = ''
      }
    },

    isCreatedOption(user) {
      return (user || {}).itemData && !(user || {}).id
    },

    userSelectFocused() {
      this.userOrPhone = null
      this.phone = ''
    },

    userOrPhoneSelectFocused() {
      this.user = null
      this.phone = ''
      this.userOrPhone = null
    },

    updateUser(payload) {
      this.user = payload
    },

    updateUserOrPhone(payload) {
      this.userOrPhone = payload
    },
  },
  validations() {
    if (this.submitted) {
      return {
        phone: {
          required,
        },
        phonePrefix: {
          required,
        },
      }
    } else {
      return {}
    }
  },
  components: {
    Blocker: () => import('@/vcs/_shared/blocker/cmp.vue'),
    UserSearchSelect,
    UserAndPhoneSearchSelect,
  },
}
